import { memo } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Link from 'components/Link';
import cleanObject from 'utils/clean-object';
import isFilterCategoryRelated from 'utils/is-filter-category-related';
import styles from './CategoryFilterList.module.scss';

function TreeFilters({
  facet,
  filterParam,
  isListExpanded,
  limitToShow = 10,
  path,
  promotion,
  terms,
}) {
  const isCategory = facet === 'Category';
  const router = useRouter();
  const paramsArray = filterParam.split(/,|%2C/);

  return (
    <>
      {terms.map(({ disallowMultiselect, displayTerm, term, id }, index) => {
        if (!term) return null;
        const paramValue = encodeURIComponent(`${facet}^tree^${id}`);

        const isAlreadySelected = paramsArray.includes(paramValue);

        const updatedParams = paramsArray
          .filter((param) => !(isCategory && isFilterCategoryRelated(param)))
          .filter((param) => {
            if (!disallowMultiselect) {
              return true;
            }

            const familyParam = encodeURIComponent(`${facet}^tree`);
            const isSameFamily = param.includes(familyParam);

            return !isSameFamily;
          })
          .filter((param) => !(isAlreadySelected && param === paramValue));

        if (!isAlreadySelected) {
          updatedParams.push(paramValue);
        }

        const filterQueryParam = updatedParams.join(',');

        return (
          <li
            key={id}
            className={classNames({
              [styles.hide_option]: index >= limitToShow && !isListExpanded,
            })}
            data-value="filter"
          >
            <Link
              shallow
              href={{
                pathname: path,
                query: cleanObject({
                  sort: router.query.sort,
                  filters: filterQueryParam,
                  promotion,
                  search: router.query.search,
                }),
              }}
              className={classNames(styles.filter_link, {
                [styles.filter_selected]: isAlreadySelected,
              })}
            >
              {displayTerm ?? term}
            </Link>
          </li>
        );
      })}
    </>
  );
}

export default memo(TreeFilters);
